import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgInformation = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8Zm0 12.5c-.563 0-1-.438-1-1 0-.563.41-1 1-1 .534 0 1 .438 1 1 0 .563-.466 1-1 1Zm2.16-4.438-1.41.876V11a.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75v-.5c0-.25.125-.5.375-.656l1.781-1.063a.67.67 0 0 0 .344-.594c0-.374-.34-.687-.716-.687H9.437a.676.676 0 0 0-.687.688.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75C7.25 6.968 8.219 6 9.41 6h1.596c1.275 0 2.244.969 2.244 2.188 0 .75-.406 1.468-1.09 1.874Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgInformation;
